import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Map of old Wix site URLs to new destinations
const REDIRECTS = {
  // Main content sections (old Wix pages → homepage anchors)
  '/about': '/#about',
  '/about-us': '/#about',
  '/contact': '/#contact',
  '/contact-us': '/#contact',
  '/upcoming-events': '/#about',
  '/events': '/#about',
  // Common Wix auto-generated paths
  '/home': '/',
  '/blank': '/',
  '/blank-page': '/',
  '/page': '/',
  // Service/product pages → relevant sections
  '/guns': '/#categories',
  '/firearms': '/#categories',
  '/electronics': '/#categories',
  '/jewelry': '/#categories',
  '/musical-instruments': '/#categories',
  '/instruments': '/#categories',
  '/power-tools': '/#categories',
  '/tools': '/#categories',
  '/archery': '/#gun-range',
  '/gun-range': '/#gun-range',
  '/range': '/#gun-range',
  // Pawn / sell process pages
  '/pawn': '/#pawn-process',
  '/pawn-loans': '/#pawn-process',
  '/sell': '/#pawn-process',
  '/how-it-works': '/#pawn-process',
  '/services': '/#pawn-process',
  // Shop online
  '/shop': 'https://alabamapawnandstorage.com/pawn-shop',
  '/shop-online': 'https://alabamapawnandstorage.com/pawn-shop',
  '/store': 'https://alabamapawnandstorage.com/pawn-shop',
  '/inventory': 'https://alabamapawnandstorage.com/pawn-shop',
  // Location / map
  '/location': '/#contact',
  '/directions': '/#contact',
  '/map': '/#contact',
  '/find-us': '/#contact',
  '/hours': '/#contact',
  // Sitemap & locations
  '/site-map': '/sitemap',
  '/service-areas': '/locations',
  '/areas-we-serve': '/locations',
  '/near-me': '/pawn-shops-near-me.html',
  '/pawn-shop-near-me': '/pawn-shops-near-me.html',
  '/pawn-shops-near-me': '/pawn-shops-near-me.html',
};

export default function OldPageRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.toLowerCase().replace(/\/$/, '') || '/';
    const target = REDIRECTS[path];

    if (target) {
      if (target.startsWith('http')) {
        // External redirect
        window.location.href = target;
      } else if (target.includes('#')) {
        // Hash link — navigate to base path then scroll
        const [base, hash] = target.split('#');
        navigate(base || '/', { replace: true });
        setTimeout(() => {
          const el = document.getElementById(hash);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      } else {
        navigate(target, { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return null;
}

export { REDIRECTS };
